import React from 'react'
import { GoogleForJobs } from '../offers/offer/mapper'

type JobPostingProps = {
  data: GoogleForJobs | null
}

const JobPosting: React.FC<JobPostingProps> = ({ data }) => {
  if (!data) {
    return null
  }

  const jobStructuredData = {
    '@context': 'https://schema.org/',
    '@type': 'JobPosting',
    title: data?.title,
    description: data?.description,
    identifier: {
      '@type': 'PropertyValue',
      name: 'Strapi',
      value: data?.id,
    },
    datePosted: data?.publishedDate,
    employmentType: data?.contractType,
    hiringOrganization: {
      '@type': 'Organization',
      name: data?.firmName,
      sameAs: data?.sameAs,
      logo: data?.firmLogo,
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        streetAddress: data?.street,
        addressLocality: data?.city,
        postalCode: data?.postalCode,
        addressCountry: 'FR',
      },
    },
    baseSalary: {
      '@type': 'MonetaryAmount',
      currency: 'EUR',
      value: {
        '@type': 'QuantitativeValue',
        currency: 'EUR',
        minValue: data?.salarymin,
        maxValue: data?.salarymax,
        unitText: 'YEAR',
      },
    },
  }
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jobStructuredData),
      }}
    />
  )
}

export default JobPosting
